export default __webpack_public_path__ + "static/media/higi-logo.e484e6d3.png";